import styled from 'styled-components';

export const BackgroundedWrapper = styled.div`
  border: 1px solid ${({ theme }) => theme.getColor('shark2')};
  border-radius: 5px;
  background: ${({ theme }) => theme.getColor('shark')};
`;
